import { render, staticRenderFns } from "./EFOS.vue?vue&type=template&id=5255cfb8&"
import script from "./EFOS.vue?vue&type=script&lang=js&"
export * from "./EFOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports